// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BEt3","footer":"styles_footer__2FYxP"};